<template>
  <VueHighcharts :options="options" ref="lineCharts"></VueHighcharts>
</template>

<script>
import VueHighcharts from 'vue2-highcharts';

const asyncData = {
  name: '',
  data: [7.0, 6.9, 9.5, 14.5],
};
export default{
  components: {
    VueHighcharts,
  },
  mounted() {
    const lineCharts = this.$refs.lineCharts;
    lineCharts.addSeries(asyncData);
    lineCharts.hideLoading();
  },
  data() {
    return {
      options: {
        chart: {
          width: '350',
          height: '200px',
          backgroundColor: 'rgba(255, 255, 255, 0.0)',
        },
        title: {
          text: '',
        },
        xAxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr'],
        },
        yAxis: {
          title: {
            text: '',
          },
        },
        tooltip: {
          crosshairs: true,
          shared: true,
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: '#666666',
              lineWidth: 1,
            },
          },
        },
        series: [],
      },
    };
  },
};
</script>
